module.exports = __webpack_public_path__ + "media/src/images/features-01-7e9098f87fc546bfb456e4f367b0f8e9.svg";